import React, { useState as classicUseState } from 'react';

import { State } from '@hookstate/core';

import CloseImage from '@assets/svg/close-ticket.svg';

import { useMutation } from 'react-query';
import { createManufacturer } from '@services/queries/manufacturers';
import { ManufacturerNameAndId } from '@services/queries/manufacturers/getManufacturersNames/getManufacturersNames';

import {
  Container,
  Label,
  Header,
  Buttons,
  StyledInput,
  BlueButton,
  WindowButton,
  WindowButtonImage,
  CloseButton,
} from './AddManufacturerContent.styles';

interface IAddFieldContent {
  openAddField: State<boolean>;
  setSelectedManufacturer: (name: string, id: string) => void;
}

const AddManufacturerContent = ({
  openAddField,
  setSelectedManufacturer,
}: IAddFieldContent) => {
  classicUseState<ManufacturerNameAndId>({ name: '', id: '' });
  const [modelName, setModelName] = classicUseState('');

  const mutationCreateManufacturer = useMutation(createManufacturer, {
    onSuccess: manufacturer => {
      setSelectedManufacturer(manufacturer.name, manufacturer.id);
      openAddField.set(false);
    },
    onError: () => {
      //  toast.error('Updated failed!');
    },
  });

  return (
    <Container>
      <Header>
        New Manufacturer
        <CloseButton
          onClick={() => {
            openAddField.set(false);
          }}
        >
          <WindowButtonImage src={CloseImage} />
        </CloseButton>
      </Header>
      <Label>Name</Label>
      <StyledInput
        type="text"
        name="name"
        value={modelName}
        onChange={e => setModelName(e.target.value)}
      />
      <Buttons>
        <WindowButton
          onClick={() => {
            openAddField.set(false);
          }}
        >
          Cancel
        </WindowButton>
        <div style={{ width: 16 }} />
        <BlueButton
          disabled={!(modelName.length > 0)}
          onClick={() => {
            mutationCreateManufacturer.mutate({
              data: {
                name: modelName,
              },
            });
          }}
        >
          + Add Manufacturer
        </BlueButton>
      </Buttons>
    </Container>
  );
};

export { AddManufacturerContent };
